export const favoritesConstants = {
    GETFAVORITES_REQUEST: 'FAVORITES_GETFAVORITES_REQUEST',
    GETFAVORITES_SUCCESS: 'FAVORITES_GETFAVORITES_SUCCESS',
    GETFAVORITES_FAILURE: 'FAVORITES_GETFAVORITES_FAILURE',

    SAVELISTING_REQUEST: 'LISTING_SAVELISTING_REQUEST',
    SAVELISTING_SUCCESS: 'LISTING_SAVELISTING_SUCCESS',
    SAVELISTING_FAILURE: 'LISTING_SAVELISTING_FAILURE',
};
